import styled from 'styled-components';
import themeData from '../../../../utils/theme/themeData';

const { typography } = themeData;

export const FormGrid = styled.div`
  display: grid;
  grid-template: 1fr / 1fr 1fr;
  gap: 20px;
  padding: 24px 16px;
`;

export const FormFieldWrapper = styled.div`
  ${({ span }) =>
    span &&
    `
    grid-column-end: span ${span};
  `}
`;

export const FormLabel = styled(typography.TitleTwoTypography)`
  margin: 0;
`;

export const FormCheckboxInput = styled.input`
  margin-top: 8px;
`;

export const FormTextInput = styled.input`
  width: 100%;
  height: 36px;
  padding: 8px 15px;
  font-size: 13px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black};
  border: 1px solid ${({ theme }) => theme.colors.grey006};
  border-radius: 4px;
  box-sizing: border-box;

  ::-webkit-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  ::-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  :-ms-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  :-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }

  &:focus {
    border: 1px solid ${({ theme }) => theme.colors.grey006};
    outline: none;
  }
`;

export const FormValidationError = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.redDark};
`;

export const AddPreparationBtn = styled(typography.BodyTextOneRegularTypography)`
  margin-inline-start: auto;
  color: ${({ theme }) => theme.colors.blueMain};
  background-color: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  &:before {
    content: '\\e910';
    font-family: 'Icomoon';
    font-size: 12px;
    margin-inline-end: 8px;
  }
`;

export const PreparationItemWrapper = styled.div`
  display: grid;
  grid-template: 1fr / 1fr 1fr 0.1fr;
  gap: 20px;
  padding-bottom: 16px;
`;

export const DeleteIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.grey005};
  border-radius: 5px;
  cursor: pointer;
  &:before {
    content: '\\e91f';
    font-family: icomoon;
    font-size: 18px;
  }
  &:hover {
    background-color: ${({ theme }) => theme.colors.redMain};
  }
`;
